export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-10.30c30c94.jpg";